import type { ComponentRef } from 'react';
import type { FilterDropdownProps } from '../../types';
import type { DateFilterFormValue } from './types';
import type { DatePicker } from 'antd';
import { useFilterDropdown } from '../../hooks/use-filter-dropdown';
import { FilterForm } from '../FilterForm';
import { DateFilterFields } from './filter-fields';
import {
  getInitialFormValues,
  getFilterToSubmit,
  getFilterToReset,
} from './DateFilterDropdown.utils';

export const DateFilterDropdown = (props: FilterDropdownProps) => {
  const { form, focusRef, onSubmit, onReset } = useFilterDropdown<
    DateFilterFormValue,
    ComponentRef<typeof DatePicker>
  >({
    ...props,
    getInitialFormValues,
    getFilterToSubmit,
    getFilterToReset,
  });

  return (
    <FilterForm form={form} filterType={props.filter.type} onSubmit={onSubmit} onReset={onReset}>
      <DateFilterFields form={form} focusRef={focusRef} options={props.filter.options} />
    </FilterForm>
  );
};
